import { MicroAppStateActions, initGlobalState } from 'qiankun';

const inititalState = {
  type: 'init', // 类型
  payload: null, // any
};

const action: MicroAppStateActions = initGlobalState(inititalState);

export default action;